import store from '~/store'

export default (to, from, next) => {
  if (!store.getters['auth/isUser']) {
    next({ name: 'login' })
  } else {
    next()
  }
}
